// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2X1Ko","is-open":"Panel_is-open__3eRhs","close":"Panel_close__iNHaq"};